module.exports = __webpack_public_path__ + "img/DSC02321.4cd6d58a.jpg";